import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import callAPI from '../../../common/call-api';
import ThemedInput from '../../../common/components/ThemedInput';
import {
  TitleBar,
  DocTitle,
  ServiceDialog,
} from '../../../common/components/Layout/StandardPageTemplate/Context';
import withQuery from '../../../common/components/withQuery';
import CurrentUserActions from '../../../redux-modules/current-user';
import LoggedInRedirect from './LoggedInRedirect';
import Template from '../components/Template';
import styles from './Login.css';

class Login extends React.Component {
  static propTypes = {
    location: PropTypes.object,
  };

  constructor(props) {
    super(props);
    const message = (props.location.query || {}).message;
    this.state = {
      isLoading: false,
      loginSuccess: false,
      individualKey: null,
      serverError: false,
      errors: {
        form: message ? [message] : [],
      },
    };
  }

  handleLoginFailure = (message, updateField) => {
    //clear password
    updateField({ fieldName: 'password', value: '' });

    return this.setState(prevState => ({
      ...prevState,
      isLoading: false,
      errors: {
        ...prevState.errors,
        form: [message],
      },
    }));
  };

  handleLogin = ({ form, updateField }) => {
      //Remove Any Previously Cached Session Storage
  sessionStorage.clear();
    // clear any existing errors
    this.setState(prevState => ({ ...prevState, errors: { form: [] } }));

    this.setState(prevState => ({
      ...prevState,
      isLoading: true,
    }));

    const { username, password } = form;
    // callApi to get authentication and handle response
    callAPI('/api/cuss/credentials', {
      method: 'POST',
      body: JSON.stringify({
        Username: username,
        Password: password,
      }),
    }).then(
      ({ resp, json }) => {
        if (resp.ok) {
          // save relevant customer data to local storage
          this.props.actions.user.login({
            id: json.key,
            token: resp.headers.get('authorizationtoken'),
            type: json.personaType,
          });
          //ga('set', 'userId', json.key);

          // update state with success
          return this.setState(prevState => ({
            ...prevState,
            isLoading: false,
            loginSuccess: true,
            individualKey: json.key,
          }));
        }
        return this.handleLoginFailure(json.message, updateField);
      },
      ({ json, resp }) => {
        if (resp.status === 500) {
          return this.setState({ serverError: true });
        }
        return this.handleLoginFailure(json.message, updateField);
      }
    );
  };

  render() {
    // if login was successful, go the appropriate location
    if (this.state.loginSuccess) {
      return (
        <LoggedInRedirect
          location={this.props.location}
          id={this.state.individualKey}
        />
      );
    }
    else if(this.props.location.query && this.props.location.query.returnUrl)
    {
      var dest = this.props.location.query.returnUrl.split('/');
      var data = [
        "advocacy",
        "business-resources",
        "news",
        "research-center",
        "legal-center",
        "member-vantage",
        "new-membership-benefits"
      ];
      if(dest.length > 1 && data.includes(dest[dest.length - 2])){
        return (
          <LoggedInRedirect
            location={this.props.location}
          />
        );
      }
    }

    const { location: { query } } = this.props;

    const loginFields = [
      {
        Component: ThemedInput,
        name: 'username',
        type: 'email',
        label: 'Email Address',
        required: true,
      },
      {
        Component: ThemedInput,
        name: 'password',
        type: 'password',
        required: true,
      },
      () => (
        <div className={styles.linkContainer} key="forgot-link">
          <Link to="/auth/forgot" className={styles.forgotLink}>
            Forgot Password
          </Link>
        </div>
      ),
    ];
    return (
      <div>
        <DocTitle title="Login | Engage | NFIB" />
        {this.state.serverError ? <ServiceDialog /> : null}
        <TitleBar title="" />
        <Template
          formState={{
            username: query.email || '',
            password: '',
          }}
          formSubmit={this.handleLogin}
          formInputs={loginFields}
          formErrors={this.state.errors.form}
          isLoading={this.state.isLoading}
          title="Login"
        />
      </div>
    );
  }
}

export default withQuery(
  connect(null, dispatch => ({
    actions: { user: bindActionCreators(CurrentUserActions, dispatch) },
  }))(Login)
);



// WEBPACK FOOTER //
// ./src/App/auth/Views/Login.js